module.exports = __webpack_public_path__ + "static/media/checkbox_active.41f0218f.svg";